module.exports = __webpack_public_path__ + "img/um.c4e86dfb.svg";